import { formatCurrency } from "@sellar-io/common";
import { twMerge } from "tailwind-merge";

export const SellarCreditBalance = ({
  available,
  spend,
  limit,
  compact = false,
}: {
  available: number | null;
  spend: number | null;
  limit: number | null;
  compact?: boolean;
}) => {
  let percentage: number | null = null;
  if (spend !== null && limit !== null) {
    if (limit > 0) {
      percentage = Math.max(0, Math.min(100, (spend / limit) * 100));
    } else {
      percentage = spend > 0 ? 100 : 0;
    }
  }
  const amount = (value: number | null) =>
    value === null ? "—" : formatCurrency(value);
  return (
    <section
      aria-label="Sellar Credit balance"
      className={twMerge(
        "flex flex-col gap-4 p-4 text-zinc-800",
        compact
          ? "gap-2 rounded-2xl border border-zinc-200 bg-white shadow-[2px_2px_16px_0_#0000000f]"
          : "border-y border-zinc-200 bg-zinc-50",
      )}
    >
      <div className="flex flex-col gap-1">
        <p className="text-sm leading-5 text-zinc-500">Available balance</p>
        <p
          className={
            compact
              ? "text-2xl leading-8 font-bold"
              : "text-3xl leading-9 font-bold tracking-[-0.6px]"
          }
        >
          {amount(available)}
        </p>
      </div>
      {percentage !== null && (
        <div
          role="progressbar"
          aria-label="Credit limit used"
          aria-valuemin={0}
          aria-valuemax={100}
          aria-valuenow={Math.round(percentage)}
          className="h-1 overflow-hidden rounded-full bg-purple-300"
        >
          <div
            className="h-full rounded-full bg-purple-600"
            style={{ width: `${percentage}%` }}
          />
        </div>
      )}
      <dl className="flex gap-4">
        <div className="min-w-0 flex-1">
          <dt className="text-sm leading-5 text-zinc-500">Spend</dt>
          <dd className="text-base leading-6 font-semibold break-words">
            {amount(spend)}
          </dd>
        </div>
        <div className="min-w-0 flex-1 text-right">
          <dt className="text-sm leading-5 text-zinc-500">Limit</dt>
          <dd className="text-base leading-6 font-semibold break-words">
            {amount(limit)}
          </dd>
        </div>
      </dl>
    </section>
  );
};
